import React from 'react';
import { useTranslation } from 'react-i18next';
import { ZigStub } from '@zignaly-open/ui';

const NoData: React.FC = () => {
  const { t } = useTranslation('common');
  return (
    <ZigStub
      title={t('no-data.title')}
      description={t('no-data.description')}
    />
  );
};

export default NoData;
